module.exports = __webpack_public_path__ + "img/11.95840178.png";